import { createFormAction } from 'redux-form-saga';
import * as productTRFormTypes from './productTRFormTypes';
import {createAction} from "redux-actions";

export const submitProductTRForm = createFormAction(productTRFormTypes.SUBMIT_PRODUCT_TR_FORM);
// export const loadForm = createAction(categoryTRFormTypes.LOAD_FORM);
